import constants from "@/config/constants";

export function convertData(row, columns, categories, allFiles) {
  const fieldType = constants.FIELD_TYPE;
  const data = {};
  columns.forEach((column) => {
    if (row[column.key]) {
      switch (column.key) {
        default:
          if (column.type === fieldType.NUMBER) {
            data[column.key] = Number(`${row[column.key] || 0}`);
          } else if (column.type === fieldType.SELECT && !!column.options?.type) {
            const category = categories.find((c) => c.type === column.options?.type && c.extra.name == row[column.key])
            data[column.key] = category?.id || row[column.key];
          } else if ([fieldType.FILE_IMAGES].includes(column.type)) {
            const fileId = allFiles.find((f) => f.extra.name.includes(row[column.key]))?.id;
            if (fileId) {
              data[column.key] = [{
                is_avatar: false,
                id: fileId
              }]
            } else {
              data[column.key] = []
            }
          } else {
            data[column.key] = `${row[column.key] || ""}`;
          }
          break;
      }
    }
  });
  return data;
}
